import React from 'react';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { initNativeCalls } from '@ifit/native-webview-interface';
import { createClients } from './client';
import App from './app';
import registerServiceWorker from './registerServiceWorker';
import './index.css';
import { shouldUseLocalData } from './util/local';

const store = createStore(combineReducers(App.reducer), applyMiddleware(thunk));
initNativeCalls(store, [...App.nativeCalls, setupApp]);

// helper for when trying to get code coverage to work
/* istanbul ignore next */
if (shouldUseLocalData() && document.getElementById('root')) {
  setupApp({ methodName: 'setupApp' });
}

function setupApp(payload) {
  if (payload.methodName !== 'setupApp') return;
  createClients(payload);
  renderApp();
}

function renderApp() {
  /* istanbul ignore next */
  window.environment = document.location.hostname === 'localhost'
    ? 'local'
    : 'production';
  const loadingElement = document.getElementById('loading');
  if (loadingElement) {
    document.body.removeChild(loadingElement);
  }
  ReactDOM.render(
    <Provider store={ store }>
      <App />
    </Provider>,
    document.getElementById('root')
  );
  registerServiceWorker();
}

export { renderApp, setupApp };


// WEBPACK FOOTER //
// ./src/index.js